module.exports = __webpack_public_path__ + "static/img/logo2.57eb262.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/logo2.png
// module id = IUU0
// module chunks = 1